import "../../../css/DesignSystem/Inputs/SearchField.css";
import { ReactComponent as TooltipIcon } from "../../../assets/icons/information.svg";
import { ReactComponent as SearchIcon } from "../../../assets/icons/search icon.svg";
import Tooltip from "../Tooltip/Tooltip";

const SearchField = ({
  id,
  label,
  value,
  onChange,
  placeholder = "Search",
  error = false,
  helperText,
  required = false,
  disabled = false,
  icon,
  OnSearch,
  tooltip,
}) => {
  const inputId = id || `search-${label?.replace(/\s+/g, "-")?.toLowerCase()}`;

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && OnSearch) {
      e.preventDefault();
      OnSearch();
    }
  };

  return (
    <div className={`ds-input-field ${error ? "ds-input-field--error" : ""}`}>
      {label && (
        
        <label
          className="ds-input-label FP_Content text-black"
          htmlFor={inputId}
        >
        <div className="row gap-xs align-center">
          {label}
          {tooltip && (
            <Tooltip content={tooltip} position="left">
              
              <TooltipIcon height={10} width={10}/>
            </Tooltip>
          )}
          {required && (
            <span className="FP_Content_Semibold text-error">*</span>
          )}
          </div>
          </label>
      )}
      <div className="ds-input-wrapper ds-input-wrapper--search">
        <input
          id={inputId}
          className="ds-input FP_Content"
          type="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          onKeyPress={handleKeyPress}
        />
        <span
          className="ds-input-icon"
          onClick={OnSearch}
          style={{ cursor: "pointer" }}
        >
          <SearchIcon />
        </span>
      </div>
      {/* {helperText && (
        <div
          className={`ds-input-helper ${error ? "ds-input-helper--error" : ""}`}
        >
          {helperText}
        </div>
      )} */}
    </div>
  );
};

export default SearchField;
